import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M16 120L240 120"
      />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M216 216h-24a8 8 0 01-8-8v-24H72v24a8 8 0 01-8 8H40a8 8 0 01-8-8v-88l29.9-67.2a8 8 0 017.3-4.8h117.6a8 8 0 017.3 4.8L224 120v88a8 8 0 01-8 8z"
      />
    </svg>
  );
}

export default Icon;
